import { useQuery } from '@tanstack/react-query';
import { ActivityLogApi } from '../apis/activity-log-api';
import CloseableErrorMessage from '../components/CloseableErrorMessage';

export const ActivityLogQueries = {
  useCompanyActivity: (companyId: number | undefined, deleted: boolean = true, days?: number, detail?: boolean) =>
    useQuery({
      queryKey: ['companyActivity', companyId, days, detail],
      queryFn: async () => await ActivityLogApi.getCompanyActivity(companyId!, days, detail),
      enabled: !!companyId && !deleted,
      onError: () => CloseableErrorMessage('Error getting company activity.'),
    }),
};
